import { LocationItem, EventItem } from './../models/Item';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { PieChartComponent } from '../piechart/piechart.component';
import { DbmanagerService} from '../services/dbmanager.service';
import { Router } from '@angular/router';
import { Color } from 'ng2-charts';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-warehouses',
  templateUrl: './warehouses.component.html',
  styleUrls: ['./warehouses.component.css']
})
export class WarehousesComponent implements OnInit, OnDestroy {

  public items: Array<Warehouseitem>;
  public locations: Map<string, LocationItem>;

  public locName = '';
  public locAddress = '';
  public locInventoryDate: string ;
  public locInventoryStatus = '';
  public locSize = '';

  public selectedLocation = '';
  public selectedLocInventory = '';

  public chartLabels: Array<string> ;
  public chartValues: Array<number> ;

  locationSubscription;

  @ViewChild('statusIcon') statusIcon: ImageBitmap;

  constructor(private dbservice: DbmanagerService, private router: Router) {

    this.locations = new Map<string, LocationItem>();
    this.items = new Array<Warehouseitem>();

    this.chartLabels = new Array<string>();
    this.chartValues = new Array<number>();
   }
  ngOnDestroy(): void {
    this.locationSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.dbservice.locations.forEach(loc => {
      this.locations.set(loc.NAME, loc);
      if (this.selectedLocation === '') {
        this.selectedLocation = loc.NAME;
        this.locationChanged(this.selectedLocation);
      }
    });

    this.locationSubscription = this.dbservice.getLocations().subscribe(locations => {
      this.chartLabels = [];
      this.chartValues = [];
      this.updateLocations(locations);
      this.updateEvents();
      if (this.selectedLocation !== '') {
        this.locationValuesUpdate(this.dbservice.locations.get(this.selectedLocation));
      }
    });

    this.updateLocations(this.dbservice.locations);
    this.updateEvents();
  }

  updateEvents(): void {
    this.dbservice.eventItems.forEach(event => {
      this.chartLabels.forEach(loc => {
        if (event.LOCATION === loc) {
          this.chartValues[this.chartLabels.indexOf(loc)]++;
        }
      });
    });
  }

  updateLocations(locations: Map<string, LocationItem>): void {
    let currentLoc = '';
    locations.forEach(loc => {
        if (currentLoc.length === 0) {
          currentLoc = loc.NAME;
        }
        if (currentLoc.localeCompare(loc.NAME) === 1) {
          currentLoc = loc.NAME;
        }
        this.locations.set(loc.NAME, loc);
        this.chartLabels.push(loc.NAME);
        this.chartValues.push(0);
      });
  }

  onClicked(location): void {
      if ((location as string).length > 0) {
        this.locationChanged(location);
        this.selectedLocation = location;
      }
  }

  onReady(name): void{
    this.updateLocations(this.dbservice.locations);
    this.updateEvents();
  }

  locationChanged(locationName) {
    if (locationName !== undefined) {
      const location = this.locations.get(locationName) ;
      this.locationValuesUpdate(location);
    }
  }

  getInventoryTitle() {
    if ((this.selectedLocInventory === 'INPROGRESS') ||
      (this.selectedLocInventory === 'STARTED')) {
        return $localize`:@@warehouses.cancelInventory:Anuluj inwentaryzację`;
      } else  {
        return $localize`:@@warehouses.startInventory:Ropocznij inwentaryzację`;
      }
  }

  getInventoryColor() {
    if ((this.selectedLocInventory === 'INPROGRESS') ||
      (this.selectedLocInventory === 'STARTED')) {
        return  '#BF2F1A';
      } else  {
        return '#0F8B00';
      }
  }

  listItemClicked(ID) {
    this.router.navigate(['/itemdetails'], {
      queryParams: {
        UID: ID
      }
    });
  }

  getType(): string {
    return this.dbservice.type;
  }

  setInventory() {
    let status = '';
    if ((this.selectedLocInventory === 'INPROGRESS') ||
        (this.selectedLocInventory === 'STARTED')) {
        status = 'CANCELED' ;
      } else {
        status = 'STARTED' ;
      }
    this.dbservice.updateInventoryStatus(status, this.selectedLocation);
  }

  locationValuesUpdate(location: LocationItem) {
    const t = new Date(location.INVENTORY_DATE); // Epoch
    t.setTime(((((location.INVENTORY_DATE) as unknown) as TimeSec).seconds * 1000));
    this.locName = location.NAME;
    this.locAddress = location.ADDRESS;
    this.locInventoryDate = new DatePipe('PL').transform(t, 'medium');
    this.locInventoryStatus = location.INVENTORY_STATUS;
    switch (location.INVENTORY_STATUS) {
      case 'STARTED':
        this.locInventoryStatus = $localize`:@@warehouses.statusStarted:Rozpoczęto`;
        break;

      case 'INPROGRESS':
        this.locInventoryStatus = $localize`:@@warehouses.statusInProgress:W trakcie`;
        break;

      case 'FINISHED':
        this.locInventoryStatus = $localize`:@@warehouses.statusFinished:Zakończono`;
        break;

      case 'CANCELED':
        this.locInventoryStatus = $localize`:@@warehouses.statusCanceled:Anulowano`;
        break;

      default:
        this.locInventoryStatus = $localize`:@@warehouses.startUnknown:Nieznany`;
        break;
    }
    this.locSize = location.SIZE;
    this.selectedLocInventory = location.INVENTORY_STATUS ;
    this.items = [];

    this.dbservice.eventItems.forEach(element => {
      if (element.LOCATION === location.NAME) {
        let status = 'unknown';
        if ((location.INVENTORY_STATUS === 'FINISHED') ||
            (location.INVENTORY_STATUS === 'INPROGRESS') ||
            (location.INVENTORY_STATUS === 'STARTED')) {
          if (element.EVENT_DATETIME > location.INVENTORY_DATE) {
              status = 'finished';
          } else {
            status = 'inprogress';
          }
        } else if (location.INVENTORY_STATUS === 'CANCELED') {
          if (element.EVENT_DATETIME > location.INVENTORY_DATE) {
              status = 'finished';
          } else {
            status = 'cancel';
          }
        }

        this.items.push(new Warehouseitem(this.dbservice.tagItems.get(element.TAG_UID).TITLE,
                                          this.dbservice.tagItems.get(element.TAG_UID).DESCRIPTION,
                                          element.TAG_UID,
                                          status));
      }
    });
  }

}

class Warehouseitem {
  constructor( public Title: string, public Desription: string , public ID: string, public Status: string) { }
}

interface TimeSec {
  seconds: number;
  miliseconds: number;
}

